<script setup>
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {ref} from "vue";
import GenerateFixModal from "@/components/actions/modals/GenerateFixModal.vue";

defineProps({
  action: {
    type: Object,
    required: true,
  },
})

const showModal = ref(false);
</script>

<template>
  <DefaultButton
    class="tw-flex tw-items-center tw-gap-2"
    size="small"
    @click="() => showModal = true"
  >
    <svg-vue
      icon="icons/sparkles-outline"
      class="tw-w-6"
    />

    <span class="tw-font-bold tw-text-sm">Generate Fix</span>
  </DefaultButton>
  <GenerateFixModal
    v-if="showModal"
    :action="action"
    @close="showModal = false"
  />
</template>
